module.exports = __webpack_public_path__ + "static/media/AULAO-DE-VESPERA.4777c077.png";